import React from 'react';
import './PartnerPage.css';

import { Heading, PageTitle } from '../../../components';
import { partners } from '../../../constants';



const PartnerPage = () => {
  return (
    <>
      {/* Page Title */}
      <PageTitle title={'partners'} page={'partners'} />

      <section className='partners'>

        {/* Section heading */}
        <Heading title={'Our partners'} subTitle={'Meet Our Valued Partners'} />

        <div className='box-container'>

          {/* Loop through the partners array to display each partner's logo */}
          {partners.map((partner, index) => {
            return (
              <div className='partner-item' key={index}>
                {/* Render the partner logo */}
                <img src={partner} alt='Partner Logo' />
              </div>
            );
            })
          }

        </div>

      </section>

    </>
  );
}

export default PartnerPage;